/**
 * Build id used for cache-busting static assets (e.g. i18n JSON).
 * Generated by scripts/set-build-id.mjs — do not edit by hand in CI.
 */
export const BUILD_ID = '46b4d7dae233';
